import { axiosPatch } from '@/api/handlers';
import { useMutation } from '@/api/hooks';
import { useInvalidateQuery } from '@/hooks';
import type { z } from 'zod';
import { queryKeyMap } from '../../../../_utils/query-keys';
import { UpdateExecutionProgressIncomeAndExpenditureFormSchema } from '../../../_models/execution-progress';

export const useUpdateExecutionProgressIncomeAndExpenditureSummary = () => {
  const { invalidate } = useInvalidateQuery();

  return useMutation({
    mutationFn: async ({
      projectId,
      ...values
    }: z.infer<typeof UpdateExecutionProgressIncomeAndExpenditureFormSchema> & {
      projectId: string;
    }) => {
      const parsed =
        UpdateExecutionProgressIncomeAndExpenditureFormSchema.parse(values);
      const payload = {
        fundAdditionalAttributes: parsed,
      };

      const res = await axiosPatch(`/api/projects/${projectId}/`, payload);
      await invalidate(queryKeyMap.project(projectId));
      return res;
    },
  });
};
